var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#4eafcb",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M448,256c-11.782,0-21.333,9.551-21.333,21.333V448h-384V64h384c0,11.782,9.551,21.333,21.333,21.333 c11.782,0,21.333-9.551,21.333-21.333V42.667c0-11.782-9.551-21.333-21.333-21.333H21.333C9.551,21.333,0,30.885,0,42.667 v426.667c0,11.782,9.551,21.333,21.333,21.333H448c11.782,0,21.333-9.551,21.333-21.333v-192 C469.333,265.551,459.782,256,448,256z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.752,91.582c-8.331-8.331-21.839-8.331-30.17,0l-236.25,236.25l-71.476-125.083 c-5.846-10.23-18.877-13.784-29.107-7.938c-10.23,5.846-13.784,18.877-7.938,29.107l85.333,149.333 c6.979,12.213,23.661,14.447,33.607,4.501l256-256C514.083,113.42,514.083,99.913,505.752,91.582z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.1d143ff4f27495fd110fdd8862308461.svg";
export { ForwardRef as ReactComponent };